import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import ProductCard from '../components/product/ProductCard';
import { Product } from '../types';
import { productService } from '../services/productService';
import { toast } from 'react-toastify';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
`;

const Header = styled.div`
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  color: var(--primary-blue);
  margin-bottom: 0.5rem;
`;

const ResultsCount = styled.p`
  color: var(--gray-dark);
  font-size: 1.1rem;
`;

const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
`;

const NoResults = styled.div`
  text-align: center;
  padding: 3rem;
  background: white;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
`;

const NoResultsTitle = styled.h2`
  color: var(--primary-blue);
  margin-bottom: 1rem;
`;

const Search: React.FC = () => {
  const location = useLocation();
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  
  // Extraer el término de búsqueda de la URL
  const searchQuery = new URLSearchParams(location.search).get('q') || '';
  
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const results = await productService.searchProducts(searchQuery);
        setProducts(results);
      } catch (err) {
        // Error handling without console logging for production
        setError('Error al buscar productos. Por favor, inténtalo de nuevo.');
        toast.error('Error al buscar productos');
      } finally {
        setLoading(false);
      }
    };
    
    if (searchQuery) {
      fetchProducts();
    } else {
      setProducts([]);
      setLoading(false);
    }
  }, [searchQuery]);
  
  return (
    <Container>
      <Header>
        <Title>Resultados de búsqueda</Title>
        <ResultsCount>
          {loading ? 'Buscando...' : 
           `${products.length} ${products.length === 1 ? 'producto encontrado' : 'productos encontrados'} para "${searchQuery}"`}
        </ResultsCount>
      </Header>
      
      {loading ? (
        <p>Cargando resultados...</p>
      ) : error ? (
        <p>{error}</p>
      ) : products.length > 0 ? (
        <ProductsGrid>
          {products.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </ProductsGrid>
      ) : (
        <NoResults>
          <NoResultsTitle>No se encontraron productos</NoResultsTitle>
          <p>Intenta con otros términos de búsqueda o navega por nuestras categorías.</p>
        </NoResults>
      )}
    </Container>
  );
};

export default Search;